<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :clearable="isClearable"
      :placeholder="placeholder"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="groupsState.loading"
          :style="{ opacity: groupsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay grupos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  computed: {
    ...mapGetters('List', [
      'groupsState'
    ]),
    optionSelected() {
      return this.listOptions.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.listOptions.length
        || this.groupsState.loading;
    },
    listOptions() {
      const officeType = (this.officeType === 'numOf' || this.officeType === 'ext')
        ? 'ext' : 'int';
      let options = [];
      if (this.showOptionAll) {
        options.push({
          value: '*',
          label: 'Todos'
        });
      }
      if (this.typeList === StepTypes.GROUP) {
        if (this.showOnlyCommissions) {
          // Permite filtrar grupos con codigo 001-XXX
          options = [...options, ...this.groupsState.list
            .filter((group) => group.isOffice === 'N'
              && group.code.length > 3
              && group.code.slice(0, 3) === '001')
            .sort(({ label: a }, { label: b }) => a.localeCompare(b))];
          return options;
        }

        if (this.showOnlyDivissions) {
          console.log('muestro divisiones');
          options = [...options, ...this.groupsState.list
            .filter((group) => group.isDivision === 'Y')
            .filter((group) => group.isOffice === 'N')
            .sort(({ label: a }, { label: b }) => a.localeCompare(b))];
          return options;
        }
        if (this.dontShowParent) {
          console.log('muestro solo hijos');
          options = [...options, ...this.groupsState.list
            .filter((group) => group.padreId)
            .filter((group) => group.isOffice === 'N')
            .sort(({ label: a }, { label: b }) => a.localeCompare(b))];
          return options;
        }

        if (this.showOnlyUnits) {
          // Muestra los grupos excepto los que incluyen el codigo 001
          options = [...options, ...this.groupsState.list
            .filter((group) => group.isOffice === 'N' && !group.code.split('-').includes('001'))];
          return options;
        }

        options = [...options, ...this.groupsState.list
          .filter((group) => group.isOffice === 'N')];
        return options;
      }
      if (this.typeList === StepTypes.OFFICE) {
        options = [...options, ...this.groupsState.list
          .filter((group) => (group.isOffice && group.isOffice === 'Y')
            && group.type === officeType)];
        return options;
      }
      if (this.typeList === StepTypes.INTERNAL_OFFICES) {
        options = [...options, ...this.groupsState.list
          .filter((group) => (group.isOffice && group.isOffice === 'Y')
            && group.type === officeType)];
        return options;
      }
      if (this.typeList === StepTypes.EXTERNAL_OFFICES) {
        options = [...options, ...this.groupsState.list
          .filter((group) => (group.isOffice && group.isOffice === 'Y')
            && group.type === officeType)];
        return options;
      }
      options = [...options, ...this.groupsState.list];
      return options;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchGroups'
    ]),
    onInput(event) {
      console.log('event', event)
      this.$emit('full-group', event);
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.groupsState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchGroups();
  },
  props: {
    name: { type: String, required: true },
    typeList: { type: Number },
    officeType: { type: String },
    label: { type: String, default: 'Dirección / Región' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    showOnlyCommissions: { type: Boolean, default: false },
    showOnlyDivissions: { type: Boolean, default: false },
    dontShowParent: { type: Boolean, default: false },
    showOnlyUnits: { type: Boolean, default: false },
    showOptionAll: { type: Boolean, default: false },
    placeholder: { type: String }
  }
};

</script>
